<body>
    <div class="intro">
        <div class="container">
            <!-- Title -->
            <div style="text-align: center;color:white">
                <h3>
                    <br><br><br>
                    <span id="title" class="pacificofont"><b><i>Copy
                                {{businessName}} Customers</i></b></span>
                    <br><br><br>
                </h3>
            </div>
            <!-- Title -->

            <!-- Search Bar -->
            <div class="form-group">
                <input id="copysearchBar" type="text"
                    class="form-control"
                    [(ngModel)]="text"
                    name="text"
                    placeholder="Search">
            </div>
            <!-- Search Bar -->



            <!-- Select Business Form -->
            <form #selectBusinessForm="ngForm"
                (ngSubmit)="copy(selectBusinessForm)">
                <label id="input_label" style="color:black" for="businessId">Select
                    Business to Copy</label>
                <div id="select_business" class="select" class="input-group
                    mb-3">
                    <div class="input-group-prepend">
                        <label style="color:black" class="input-group-text"
                            for="inputGroupSelect01">BUSINESS</label>
                    </div>
                    <select required name="businessId" ngModel
                        requirred
                        class="custom-select"
                        id="inputGroupSelect01">
                        <option *ngFor="let business of businessList"
                            value="{{
                            business.businessId }}">{{
                            business.businessName }}</option>
                    </select>
                    <span id="input_label"
                        *ngIf="businessId.invalid &&
                        businessId.touched"
                        style="color:red"><b>**Please Select Business</b></span>
                </div>

                <!-- Submit Button -->
                <div *ngIf="show_copy === false">
                    <button
                        style="position:absolute;top:220px;margin-left:1030px;"
                        type="submit"
                        id="submit_button"
                        [disabled]="selectBusinessForm.invalid"
                        class="btn
                        btn-warning"><i class="fa
                            fa-file-copy"></i>Copy</button>
                </div>

                <div *ngIf="show_copy === true">

                    <button
                        style="position:absolute;top:220px;margin-left:1030px;"
                        type="button"
                        class="btn btn-warning"
                        disabled>
                        <span class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                        Copying</button>

                </div>
                <!-- Submit Button -->


            </form>
            <!-- Select Business Form -->

            <!-- Select All Button -->
            <div *ngIf="showSelectAll === false">
                <button
                    style="position:absolute;top:220px;margin-left:770px;"
                    type="button"
                    class="btn btn-primary" (click)="selectAll()"
                    id="selectAllbutton">Select All</button>
            </div>

            <div *ngIf="showSelectAll === true">
                <button
                    style="position:absolute;top:220px;margin-left:770px;"
                    type="button"
                    class="btn btn-primary" (click)="UnselectAll()"
                    id="selectAllbutton">Unselect All</button>
            </div>
            <!-- Select All Button -->

            <!-- Delete All Button -->
            <div *ngIf="showDeleteAll === false">
                <button
                    style="position:absolute;top:220px;margin-left:900px;"
                    type="button"
                    class="btn btn-danger" (click)="DeleteAllCustomers()"
                    id="selectAllbutton">Delete All</button>
            </div>

            <div *ngIf="showDeleteAll === true">
                <button
                    style="position:absolute;top:220px;margin-left:900px;"
                    type="button"
                    class="btn btn-danger"
                    disabled>
                    <span class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                    Deleting</button>
            </div>
            <!-- Delete All Button -->


            <div *ngIf="text === '';then content else
                other_content"></div>
            <!-- Customer Display Table -->
            <ng-template #content>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th (click)="sort('customerId')" class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Sr</th>
                            <th (click)="sort('customerName')"
                                class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Name</th>
                            <th (click)="sort('customerContact')"
                                class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Contact</th>
                            <th (click)="sort('customerAddress')"
                                class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Address</th>
                            <th (click)="sort('customerAadharNumber')"
                                class="table-dark"><i class="fa fa-sort"></i>&nbsp;Aadhar
                                No.</th>
                            <th (click)="sort('customerPanNumber')"
                                class="table-dark"><i class="fa fa-sort"></i>&nbsp;Pan
                                No.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-light" *ngFor="let
                            customer
                            of
                            customerList | orderBy: key :
                            reverse|
                            paginate : {id :
                            'listing_pagination',
                            itemsPerPage : 10,
                            currentPage : page,
                            totalItems : totalLength
                            }; let i=index">
                            <!-- <div *ngIf="{{customer.customerPending}} === '0' "> -->
                            <td><div class="custom-control custom-checkbox">
                                    <input (click)="addCustomerIds(customer)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id={{i+1}}
                                        [checked]="customer.customerStatus">
                                </div></td>
                            <td>{{customer.customerName}}</td>
                            <td>{{customer.customerContact}}</td>
                            <td>{{customer.customerAddress}}</td>
                            <td>{{customer.customerAadharNumber}}</td>
                            <td>{{customer.customerPanNumber}}</td>
                            <!-- </div> -->
                        </tr>

                    </tbody>
                </table>
                <div>
                    <pagination-controls style="color:white;"
                        id="listing_pagination"
                        (pageChange)="page=
                        $event"></pagination-controls>
                </div>
            </ng-template>
            <!-- Customer Display Table -->

            <!-- Customer Display Table -->
            <ng-template #other_content>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th (click)="sort('customerId')" class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Sr</th>
                            <th (click)="sort('customerName')"
                                class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Name</th>
                            <th (click)="sort('customerContact')"
                                class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Contact</th>
                            <th (click)="sort('customerAddress')"
                                class="table-dark"><i
                                    class="fa fa-sort"></i>&nbsp;Address</th>
                            <th (click)="sort('customerAadharNumber')"
                                class="table-dark"><i class="fa fa-sort"></i>&nbsp;Aadhar
                                No.</th>
                            <th (click)="sort('customerPanNumber')"
                                class="table-dark"><i class="fa fa-sort"></i>&nbsp;Pan
                                No.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-light" *ngFor="let
                            customer
                            of
                            customerList | orderBy: key :
                            reverse|filter:text; let i=index">
                            <!-- <div *ngIf="{{customer.customerPending}} === '0' "> -->
                            <td><div class="custom-control custom-checkbox">
                                    <input (click)="addCustomerIds(customer)"
                                        type="checkbox"
                                        class="custom-control-input"
                                        id={{i+1}}
                                        [checked]="customer.customerStatus"></div>
                                <td>{{customer.customerName}}</td>
                                <td>{{customer.customerContact}}</td>
                                <td>{{customer.customerAddress}}</td>
                                <td>{{customer.customerAadharNumber}}</td>
                                <td>{{customer.customerPanNumber}}</td>
                                <!-- </div> -->
                            </tr>

                        </tbody>
                    </table>
                </ng-template>
                <!-- Customer Display Table -->

            </div>
        </div>
    </body>
